(() => {
  const routes = window.routes || {};
  const cartAddUrl = `${routes.cart_add_url || '/cart/add'}.js`;
  const cartUrl = routes.cart_url || '/cart';
  const cartJsonUrl = `${cartUrl}.js`;
  let cartCount = 0;
  let toastTimer;

  const cartDock = () => {
    let dock = document.querySelector('.pc-cart-dock');
    if (dock) return dock;
    dock = document.createElement('a');
    dock.className = 'pc-cart-dock';
    dock.href = cartUrl;
    dock.setAttribute('aria-label', 'View cart');
    dock.innerHTML = '<span>Cart</span><b>0</b>';
    document.body.appendChild(dock);
    return dock;
  };

  const updateCart = (cart) => {
    cartCount = cart.item_count || 0;
    document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
      bubble.innerHTML = `<span aria-hidden="true">${cartCount}</span><span class="visually-hidden">${cartCount} items</span>`;
    });
    const dock = cartDock();
    dock.querySelector('b').textContent = cartCount;
    dock.classList.toggle('is-visible', cartCount > 0 && window.scrollY > 120);
  };

  const showToast = (title) => {
    let toast = document.querySelector('.pc-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'pc-cart-toast';
      toast.setAttribute('role', 'status');
      toast.innerHTML = '<div><strong>Added to cart</strong><span></span></div><a>View cart <b>→</b></a>';
      document.body.appendChild(toast);
    }
    toast.querySelector('span').textContent = title;
    toast.querySelector('a').href = cartUrl;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 3600);
  };

  const refreshCart = async () => {
    const response = await fetch(cartJsonUrl, { headers: { Accept: 'application/json' } });
    if (response.ok) updateCart(await response.json());
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-type="add-to-cart-form"]');
    if (!form || !form.closest('.pc-card-actions')) return;
    event.preventDefault();
    event.stopImmediatePropagation();

    const button = form.querySelector('.pc-card-action');
    const label = button?.querySelector('.pc-card-action__label');
    const originalLabel = label?.textContent;
    if (button) {
      button.disabled = true;
      button.classList.add('is-adding');
    }
    if (label) label.textContent = 'Adding';

    try {
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form),
      });
      if (!response.ok) throw new Error('Unable to add this item to the cart.');
      const item = await response.json();
      await refreshCart();
      const title = form.closest('.card-wrapper')?.querySelector('.card__heading a')?.textContent?.trim() || item.title || 'Item';
      showToast(title);
      if (label) label.textContent = 'Added';
      window.setTimeout(() => { if (label) label.textContent = originalLabel || 'Add to cart'; }, 1500);
    } catch (error) {
      if (label) label.textContent = 'Try again';
    } finally {
      if (button) {
        button.disabled = false;
        button.classList.remove('is-adding');
      }
    }
  }, true);

  window.addEventListener('scroll', () => {
    const dock = document.querySelector('.pc-cart-dock');
    if (dock && cartCount > 0) dock.classList.toggle('is-visible', window.scrollY > 120);
  }, { passive: true });

  refreshCart().catch(() => {});
})();
